var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.439 16.3586V4.47858L6.952 7.96558L5.46201 6.43158L11.5 0.392578L17.538 6.4306L16.048 7.9646L12.561 4.4776V16.3576L10.439 16.3586ZM3.44901 21.6076C3.112 21.6144 2.77717 21.552 2.46519 21.4244C2.1532 21.2968 1.87067 21.1066 1.635 20.8656C1.394 20.6299 1.20384 20.3474 1.07622 20.0354C0.94861 19.7234 0.886259 19.3886 0.893012 19.0516V15.2166H3.014V19.0516C3.01505 19.1082 3.02766 19.1641 3.05105 19.2156C3.07443 19.2672 3.1081 19.3134 3.15 19.3516C3.18811 19.3935 3.23439 19.4272 3.28597 19.4506C3.33756 19.4739 3.39337 19.4865 3.45 19.4875H19.55C19.6066 19.4865 19.6625 19.4739 19.714 19.4506C19.7656 19.4272 19.8119 19.3935 19.85 19.3516C19.8919 19.3134 19.9256 19.2672 19.949 19.2156C19.9724 19.1641 19.9849 19.1082 19.986 19.0516V15.2166H22.107V19.0516C22.1138 19.3886 22.0514 19.7234 21.9238 20.0354C21.7962 20.3474 21.606 20.6299 21.365 20.8656C21.1293 21.1066 20.8468 21.2968 20.5348 21.4244C20.2228 21.552 19.888 21.6144 19.551 21.6076H3.44901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteUploadIcon);
export default __webpack_public_path__ + "static/media/white-upload-icon.485f534ccaf5139e7b58ec0473e3672a.svg";
export { ForwardRef as ReactComponent };